(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-bundle-product"]) return;
  try {
    
  $(".swatches__form--label").click(function(){
    setTimeout(function() {
        if ($(".AddtoCart").hasClass("disabled")) {
            $("#klaviyo-stock2, #klaviyo-stock").show();
        }
    }, 1000); // 1000 milliseconds = 1 second
});


  } catch(e) { console.error(e); }
})();
})();
